module.exports = __webpack_public_path__ + "assets/img/ydsfh.02a957f6.png";